


















import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SponsorOrgSelector from '@superUI/Selectors/SponsorOrgSelector'
import BrandRepForm from '@superUI/Forms/BrandRepForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "BrandRepCreate"
  components: { Back, SuperContainerView, SponsorOrgSelector, BrandRepForm, RequestButton }
  resources:
    newBrandRep:
        resourceName: 'brand_rep'
        slug: 'brand_reps/new'
  vue:
    data: ->
      selectedSponsorId: null
      selectedMultiSponsorId: []

    mounted: () ->
      @initializeSelectedSponsor()
    
    computed:
      sponsorIsSelected: ->
        return true if @$route.query.sponsorId
        @selectedSponsorId || @selectedMultiSponsorId.length

      errors: ->
        @formErrors?.newBrandRep || {}

    methods:
      onSave: (item) -> @$router.push({ name: 'BrandRepShowPage', params: { brandRepId: item.id } })

      hiSave: ->
        if @selectedMultiSponsorId.length
          @prime.newBrandRep.sponsor_ids = @selectedMultiSponsorId
        else
          @prime.newBrandRep.sponsor_id = @selectedSponsorId

        @saveItem('prime.newBrandRep')

      hiBack: ->
        if @selectedSponsorId || @selectedMultiSponsorId.length
          @selectedSubSponsorId = null
          @selectedSponsorId = null
          @selectedMultiSponsorId = []

      hiSponsorSelected: (selectedSponsor) ->
        @selectedSponsorId = selectedSponsor.id

      hiMultiSponsorSelected: (selectedSponsorsList) ->
        @selectedMultiSponsorId = selectedSponsorsList.map((sponsor) -> sponsor.id)
      
      initializeSelectedSponsor: ->
        sponsor_id = @$route.params.sponsor_id || @$route.query.sponsorId
        @selectedMultiSponsorId.push sponsor_id

export default VueOptions.vue settings
